import Vue from "vue";

const DEFAULT_ICON_KEY = 'generic';
const DEFAULT_COLOR    = '#9e9e9e';

const ICON_MAP = {
  generic:          require("@/assets/img/agenda/generic_icon.png"),
  economy:          require("@/assets/img/agenda/neweconomy_icon.png"),
  infrastructure:   require("@/assets/img/agenda/infrastruktura.png"),
  innovations:      require("@/assets/img/agenda/innovation_icon.png"),
  visegrad:         require("@/assets/img/agenda/grupa-wyszechradzka.png"),
  society:          require("@/assets/img/agenda/society_icon.png"),
  business:         require("@/assets/img/agenda/business_icon.png"),
  investments:      require("@/assets/img/agenda/development_icon.png"),
  europe_integration: require("@/assets/img/agenda/europe_icon_ue.png"),
  europe_world:     require("@/assets/img/agenda/europe_icon.png"),
  international:    require("@/assets/img/agenda/international_icon.png"),
  plenary:          require("@/assets/img/agenda/plenary_session.png"),
  special_events:   require("@/assets/img/agenda/special_events.png"),
  slovak_forum:     require("@/assets/img/agenda/slovak_forum.png"),
  cybersafety:      require("@/assets/img/agenda/cybersafety.png"),
  energy:           require("@/assets/img/agenda/energy_icon.png"),
  media:            require("@/assets/img/agenda/words_icon.png"),
  health:           require("@/assets/img/agenda/health_icon.png"),
  regions:          require("@/assets/img/agenda/region_icon.png"),
  reforms:          require("@/assets/img/agenda/reforms_icon.png"),
  hungary:          require("@/assets/img/agenda/wegry_icon.png"),
  polonia:          require("@/assets/img/agenda/polonia_icon.png"),
  carpathians:      require("@/assets/img/agenda/carpatian_icon.png"),
  lesser_poland:    require("@/assets/img/agenda/lesserpoland_icon.png"),
  sgh:              require("@/assets/img/agenda/sgh_icon.png"),
  cultural:         require("@/assets/img/agenda/culture_icon.png"),
  management:       require("@/assets/img/agenda/management_icon.png"),
};

export function getIconByKey(key, useDefault = false) {
  if (key && ICON_MAP[key]) return ICON_MAP[key];
  return useDefault ? ICON_MAP[DEFAULT_ICON_KEY] : null;
}

export { DEFAULT_COLOR };

export function hexToFilter(hex) {
  if (!hex) return 'none';
  const h = hex.replace('#', '');
  if (h.length !== 6) return 'none';
  const r = parseInt(h.substr(0, 2), 16) / 255;
  const g = parseInt(h.substr(2, 2), 16) / 255;
  const b = parseInt(h.substr(4, 2), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let hue = 0, sat = 0;
  if (max !== min) {
    const d = max - min;
    sat = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) hue = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) hue = (b - r) / d + 2;
    else hue = (r - g) / d + 4;
    hue /= 6;
  }
  hue = Math.round(hue * 360);
  sat = Math.round(sat * 100);
  const lp = Math.round(l * 100);
  return `brightness(0) invert(1) sepia(1) saturate(${Math.max(sat * 5, 100)}%) hue-rotate(${hue - 38}deg) brightness(${lp + 20}%)`;
}

// kept for backward compatibility
Vue.filter('panel-icon', function (val) {
  return ICON_MAP["economy"];
});
